import React from 'react';
import '../styles/ARVEstimateDescription.css';
import { colour } from '../styles/GlobalStyles';
import { Sparkle } from '../assets/icons';
import { ChatActionRequired, Typewriter } from '../components';
import { renderHTML } from '../functions';
import { HugeiconsIcon } from '@hugeicons/react';
import { GuestHouseIcon } from '@hugeicons/core-free-icons';
import { Wand } from '../assets/icons';

function ARVEstimateDescription(props) {
    const arvMessages = props.arvMessages;
    const loading = props.loading;
    const textAreaHeight = props.textAreaHeight;
    const compsChanged = props.compsChanged;
    const getARV = props.getARV;
    const arvLoading = props.arvLoading;
    const typeOutText = props.typeOutText;
    const setTypeOutText = props.setTypeOutText;
    // const readOnly = props.readOnly;
    // const arvDescription = props.arvDescription;
    const scenarios = props.scenarios;
    const actionRequired = props.actionRequired;
    const selectScenario = props.selectScenario;

    const textFinished = () => {
        setTypeOutText(false);
    };

    return (
        <div 
            className="arv-estimate-description-container"
            style={{ '--text-area-height': `${textAreaHeight}px` }}
        >
            <div className="arv-estimate-text-container">
                {
                    arvMessages.map((item, index) =>
                        item.role === "system" || item.role === "user" ?
                        null
                        :
                        item.role === "action_required" ?
                        <ChatActionRequired
                            scenarios={scenarios}
                            actionRequired={actionRequired}
                            textFinished={textFinished}
                            typeOutText={typeOutText}
                            selectScenario={selectScenario}
                            timeline={false}
                            darkMode={false}
                            key={index}
                        />
                        :
                        item.role === "event" ?
                        <div 
                            className="arv-estimate-event-element"
                            key={index}
                        >
                            <div className="arv-estimate-event-border">
                            </div>
                            {
                                item.content.includes("Comps selection") ?
                                <HugeiconsIcon icon={GuestHouseIcon} size={13} color={colour.gray05} />
                                :
                                item.content.includes("ARV Estimate Regenerated") || item.content.includes("strategy selected") ?
                                <Wand fill={colour.gray05} className="arv-estimate-description-wand-icon" />
                                :
                                null
                            }
                            <span className="body-regular colour-secondary block-text text-align-center">
                                {item.content}
                            </span>
                            <div className="arv-estimate-event-border">
                            </div>
                        </div>
                        :
                        <div 
                            className={"arv-estimate-text-element " + (item.role === "user_chat" ? "arv-estimate-text-bubble" : "")}
                            key={index}
                        >
                            {
                                item.role === "assistant" &&
                                <div className="arv-estimate-sparkle-container">
                                    <Sparkle
                                        fill={colour.gray06}
                                        className=""
                                        gradient={false}
                                    />
                                </div>
                            }
                            <div className={"arv-estimate-text-content-container " + (item.role === "assistant" ? "arv-estimate-text-assistant-width" : "")}>
                                {
                                    (index + 1) === arvMessages.length && item.role === "assistant" && typeOutText === true ?
                                    <Typewriter
                                        text={item.content}
                                        delay={10}
                                        commaDelay={0}
                                        fullStopDelay={0} 
                                        play={true}
                                        className="body-regular colour-primary block-text white-space-pre-wrap typewriter-text-gap"
                                        isHTML={true}
                                        onComplete={textFinished}
                                    />
                                    :
                                    <div
                                        className={"body-regular colour-primary typewriter-text-gap"}
                                        dangerouslySetInnerHTML={{ __html: renderHTML(item.content) }}
                                    />
                                }
                            </div>
                        </div>
                    )
                }
                {
                    arvLoading === true ?
                    <div className="arv-estimate-event-element">
                        <span className="body-bold colour-primary">
                            Regenerating ARV...
                        </span>
                    </div>
                    :
                    compsChanged === true && loading === false ?
                    <div className="arv-estimate-event-element">
                        <div 
                            className="text-button button-row gap-x-small"
                            onClick={() => getARV()}
                        >
                            <Wand fill={colour.gray05} className="arv-estimate-description-wand-icon" />
                            <span className="body-regular colour-primary">
                                Regenerate ARV
                            </span>
                        </div>
                    </div>
                    :
                    null
                }
                {
                    loading === true &&
                    <div className="arv-estimate-text-element">
                        <span className="body-bold colour-primary">
                            Reasoning..
                        </span>
                    </div>
                }
            </div>
        </div>
    )
};

export default ARVEstimateDescription;